import React from 'react';
import classnames from 'classnames';

import style from './index.less';
import MyIcon from '../my-icon';

const backgroundMap = {
  agent_redirect: 'operate', // 客服转接 1
  client_redirect: 'operate', // 访客主动转接 1
  system_redirect: 'operate', // 客服不在线, 对话被自动转接 1
  timeout_redirect: 'operate', // 未及时回复, 对话被自动转接给 1
  visit_inviting: '', // 邀请顾客对话 （可以弃用？） 0
  agent_change_attr: 'operate', // 修改了顾客信息 1
  agent_change_name: 'operate', // 修改了顾客姓名 1
  client_change_attr: 'operate', // 添加访客字段
  init_conv: 'start', // 创建对话 1
  allocate_delayed: 'start', // 无消息访客过滤进入对话 1
  prechat_survey: 'start', // 顾客通过询前表单选择
  end_conv_agent: 'end', // 客服主动结束对话 1
  end_conv_timeout: 'end', // 超时结束对话 1
  end_conv_baidu_robot: 'end', // 百度主动结束对话
  end_conv_client: 'end', // 系统自动结束对话
  ticket_status_change: 'operate', // 留言状态改变 0
  ticket_redirect: 'operate', // 留言指派给 0
  ticket_reopen: 'reopen',
  ticket_close: 'disable',
  ticket_processed: 'start',
  invite_evaluation: 'operate', // 邀请评价 1
  client_evaluation: 'operate', // 顾客评价 1
  client_add_tag: 'operate', // 添加顾客标签
  client_remove_tag: 'end', // 删除顾客标签
  add_chat_tag: 'operate', // 添加对话标签
  delete_chat_tag: 'end', // 删除顾客标签
  switch_human: 'start', // 转人工
  bot_redirect_auto: 'start',
  bot_redirect_manual: 'start',
  bot_redirect_keyword: 'start',
  bot_redirect_mpush: 'start',
  bot_redirect_other: 'start',
  summary_button: '', // 对话小结（可删除，目前小结为空也会展示）
  agent_send_card: 'operate', // 发送线索索取 1
  client_reply_card: 'operate', // 获取对方线索 1
  mpush_clue: 'operate', // 智能引导获取线索 1
  withdraw_msg: 'operate', // 消息撤回 1
  visit_black_add: 'end', // 拉黑
  visit_black_del: 'operate',
  visit_black_approve: 'end', // 申请拉黑访客
  visit_black_reject: 'operate', // 拒绝拉黑访客申请
  agent_send_sensitive_words: 'operate', // 企业敏感词
  send_message_fail: 'end',
  bcp_offline: 'end'
};

const iconMap = {
  agent_redirect: 'ecoboost-iconfontic_move2', // 客服转接 1
  client_redirect: 'ecoboost-iconfontic_move2', // 访客主动转接 1
  system_redirect: 'ecoboost-iconfontic_move2', // 客服不在线, 对话被自动转接 1
  timeout_redirect: 'ecoboost-iconfontic_move2', // 未及时回复, 对话被自动转接给 1
  visit_inviting: '', // 邀请顾客对话 （可以弃用？） 0
  agent_change_attr: 'ecoboost-iconfontic_add2', // 修改了顾客信息 1
  agent_change_name: 'ecoboost-iconfontic_add2', // 修改了顾客姓名 1
  client_change_attr: 'ecoboost-iconfontic_add2', // 回呼修改电话号码
  init_conv: 'ecoboost-iconfontic_chat1', // 创建对话 1
  allocate_delayed: 'ecoboost-iconfontic_chat1', // 顾客通过询前表单选择 1
  prechat_survey: 'ecoboost-iconfontic_chat1', // 无消息访客过滤进入对话
  end_conv_agent: 'ecoboost-iconfontic_chat1', // 客服主动结束对话 1
  end_conv_timeout: 'ecoboost-iconfontic_chat1', // 超时结束对话 1
  end_conv_baidu_robot: 'ecoboost-iconfontic_chat1', // 百度主动结束对话
  end_conv_client: 'ecoboost-iconfontic_chat1', // 系统自动结束对话
  ticket_status_change: 'ecoboost-iconfontic_edit1', // 留言状态改变
  ticket_redirect: 'ecoboost-iconfontic_zhuanjiao1', // 留言指派
  ticket_reopen: 'ecoboost-iconfontic_chongxing1', // 重新打开留言
  ticket_close: 'ecoboost-iconfontic_close1', // 关闭留言
  ticket_processed: 'ecoboost-iconfontic_jiejue1', // 解决留言
  invite_evaluation: 'ecoboost-iconfontic_send1', // 邀请评价 1
  client_evaluation: 'ecoboost-iconfontic_add2', // 顾客评价 1
  client_add_tag: 'ecoboost-iconfontic_add2', // 添加标签
  client_remove_tag: 'ecoboost-iconfontic_delete1', // 删除标签
  update_conv_tag: 'ecoboost-iconfontic_add2', // 更新对话标签
  switch_human: 'ecoboost-iconfontic_move2', // 转人工
  bot_redirect_auto: 'ecoboost-iconfontic_move2',
  bot_redirect_unsolved: 'ecoboost-iconfontic_move2',
  bot_redirect_manual: 'ecoboost-iconfontic_move2',
  bot_redirect_force: 'ecoboost-iconfontic_move2',
  bot_redirect_keyword: 'ecoboost-iconfontic_move2',
  bot_redirect_mpush: 'ecoboost-iconfontic_move2',
  bot_redirect_other: 'ecoboost-iconfontic_move2',
  summary_button: '', // 对话小结（可删除，目前小结为空也会展示）
  agent_send_card: 'ecoboost-iconfontic_send1', // 发送线索索取 1
  client_reply_card: 'ecoboost-iconfontic_add2', // 获取对方线索 1
  mpush_clue: '', // 智能引导获取线索 1
  withdraw_msg: 'ecoboost-iconfontic_chehui', // 消息撤回 1
  client_withdraw_msg: 'ecoboost-iconfontic_chehui', // 消息撤回 1
  visit_black_add: 'ecoboost-iconfontic_delete1',
  visit_black_del: 'ecoboost-iconfontic_add2',
  visit_black_approve: 'ecoboost-iconfontic_delete1', // 申请拉黑访客
  visit_black_reject: 'ecoboost-iconfontic_add2', // 拒绝拉黑访客申请
  agent_send_sensitive_words: 'ecoboost-iconfontic_chat1',
  send_message_fail: 'ecoboost-iconfontinfo-circle',
  bcp_offline: 'ecoboost-iconfontinfo-circle',
  copy_statistics: 'ecoboost-iconfontic_add2',
  end_trusteeship: 'ecoboost-iconfonticon_interface_action', // 事件通知
  quick_btn_click: 'ecoboost-iconfontic_add2',
  conv_redirect_summary: 'ecoboost-iconfontic_add2',
  phone_check: 'ecoboost-iconfontic_add2'
};

const Icon = ({ action, className }) => {
  const background = backgroundMap[action] || 'operate';
  const iconfont = iconMap[action] || 'ecoboost-iconfontic_chat1';
  return (
    <div className={classnames(style['event-icon-bg'], style[background], className)}>
      <MyIcon type={iconfont} />
    </div>
  );
};

export default Icon;
